// extracted by mini-css-extract-plugin
module.exports = {"container":"OutletCard_container__GXuqp","selected":"OutletCard_selected__U7C25","outletInfo":"OutletCard_outletInfo__ik76D"};